import React from 'react';
import { Button, Typography, Box } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import * as xlsx from 'xlsx';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { useRestaurantFileUpload } from '../../hooks/useRestaurantFileUpload';

interface FileUploadSectionProps {
  onRestaurantsExtracted: (restaurants: string[]) => void;
  onError: (message: string) => void;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  onRestaurantsExtracted,
  onError,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { uploadedFile, restaurantCount, handleFileUpload } =
    useRestaurantFileUpload({
      onRestaurantsExtracted,
      onError,
    });

  return (
    <Box className={classes.section}>
      <Typography variant="subtitle1" className={classes.sectionTitle}>
        {t('attributeMassUpdate.restaurantNumbers')}
      </Typography>
      <Typography variant="caption" className={classes.helpText}>
        {t('attributeMassUpdate.uploadFileMessage')}
      </Typography>
      <Box className={classes.fileUploadContainer}>
        <input
          accept=".csv,.xlsx,.xls"
          className={classes.fileInput}
          id="file-upload"
          type="file"
          onChange={handleFileUpload}
        />
        <label htmlFor="file-upload">
          <Button
            variant="outlined"
            component="span"
            startIcon={<PublishIcon />}
            className={classes.uploadButton}
          >
            {t('attributeMassUpdate.uploadFile')}
          </Button>
        </label>
        <Button
          variant="text"
          startIcon={<GetAppIcon />}
          onClick={handleDownloadDemo}
          className={classes.demoButton}
        >
          {t('attributeMassUpdate.downloadTemplate')}
        </Button>
      </Box>
      {uploadedFile && (
        <Box className={classes.fileInfo}>
          <Typography variant="body2">
            <strong>{t('attributeMassUpdate.file')}:</strong>{' '}
            {uploadedFile.name}
          </Typography>
          <Typography variant="body2">
            <strong>{t('attributeMassUpdate.restaurantsFound')}:</strong>{' '}
            {restaurantCount}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default FileUploadSection;

function handleDownloadDemo() {
  const demoData = [
    ['Restaurant Number'],
    ['12345'],
    ['67890'],
    ['11111'],
    ['22222'],
  ];

  const worksheet = xlsx.utils.aoa_to_sheet(demoData);
  const workbook = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(workbook, worksheet, 'Restaurants');

  // Generate file and trigger download
  xlsx.writeFile(workbook, 'attribute_mass_update_demo.xlsx');
}
